import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import MDTypography from './MDTypography';

function ShowQRCodeDialog({ open, onClose, qrCode, qrCodeURL }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                QR Code
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    size="large">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                {qrCodeURL && (
                    <img src={qrCodeURL} alt="QR Code" style={{ maxWidth: '100%', maxHeight: 300 }} />
                )}
                <MDTypography >{qrCode}</MDTypography>
            </DialogContent>
        </Dialog>
    );
}

ShowQRCodeDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    qrCode: PropTypes.node.isRequired, // Pass a QR code component or <img>
};

export default ShowQRCodeDialog;